import { ROUTES } from '../router/config';

export const getPublicRouteUrl = (route: string, isLoggedIn: boolean): string => {
  return isLoggedIn ? route : `${ROUTES.LOGIN}?next_page=` + route;
};

export const redirectToRoute = (route: string): void => {
  window.location.href = route;
};

export const redirectToInternalServices = (): void => {
  redirectToRoute(ROUTES.INTERNAL_SERVICES);
};
